import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../../models';

/** Representa o Filter da entidade UnidadeNegocioMercado */
export class UnidadeNegocioMercadoFilter implements Filter {
    situacaoMercado: number;
    situacoesMercados: number[] = [];

    /** Cria os parâmetros do filtro */
    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Situação do mercado
        if (this.situacaoMercado) {
            params = params.append('situacaoMercado', this.situacaoMercado.toString());
        }
        this.situacoesMercados?.forEach(situacaoMercado => {
            params = params.append('situacaoMercado', situacaoMercado.toString());
        })

        return params;
    }

    clear() {
        this.situacaoMercado = null;
        this.situacoesMercados = [];
    }
}

